module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust2_m.3f5338a0bc7b315d7beb127420a460aa.png";